import Vue from "vue";
import VueRouter from "vue-router";
import DashboardLayout from "../views/Layouts/DashboardLayout.vue";
import Login from "../views/Auth/Login.vue";
import Register from "../views/Auth/Register.vue";
import ForgetPassword from "../views/Auth/ForgetPassword.vue";
import ResetPassword from "../views/Auth/ResetPassword.vue";
import authenticated from "../middleware/authenticated";

import DashboardRoute from "./DashboardRoute.js"

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    component: DashboardLayout,
    children: [...DashboardRoute]
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: authenticated,
      title: "Login",
    }
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      middleware: authenticated,
      title: "Register",
    }
  },
  {
    path: "/forget-password",
    name: "ForgetPassword",
    component: ForgetPassword,
    meta: {
      middleware: authenticated,
      title: "Forget Password",
    }
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      middleware: authenticated,
      title: "Reset Password",
    }
  },

];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  

  return next();
});

router.afterEach((to) => {
  //change page title after route change
  if (to.meta.title) {
    Vue.nextTick(() => {
      document.title = `${to.meta.title} | ${process.env.VUE_APP_TITLE}`
    })
  }
})

export default router;
